import React, { useSyncExternalStore } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { backControl, hasInSiteHistory } from '../utils/backLink';

// The back control on a public detail page (#4602; the rule is in
// utils/backLink.js). A visitor who came from another page of ours steps back
// in history, and ScrollToTop puts them back where they were on that page; a
// direct arrival gets a plain link to the index.
//
// The href is always the index, so the prerendered HTML (#4484) carries a
// real link that works before the bundle runs, and a middle-click opens the
// index. History is read only in the browser: the server snapshot is "direct
// arrival", which is what the build prerendered, so hydration never meets a
// different label; a visitor with history behind them gets "Back" one render
// later.
const subscribe = (onChange) => {
    window.addEventListener('popstate', onChange);
    return () => window.removeEventListener('popstate', onChange);
};
const readInSiteHistory = () => hasInSiteHistory(window.history.state);
const directArrival = () => false;

export default function BackLink({ fallbackTo, fallbackLabel, className, iconClassName = 'h-3.5 w-3.5', testId }) {
    const navigate = useNavigate();
    const inSiteHistory = useSyncExternalStore(subscribe, readInSiteHistory, directArrival);
    const control = backControl({ inSiteHistory, fallbackTo, fallbackLabel });

    const onClick = (e) => {
        if (!control.goBack) return;
        // A modified click (new tab, new window) keeps the link's own href.
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        navigate(-1);
    };

    return (
        <Link to={control.to} onClick={onClick} className={className} data-testid={testId} data-back={control.goBack ? 'history' : 'index'}>
            <ArrowLeftIcon className={iconClassName} aria-hidden="true" /> {control.label}
        </Link>
    );
}
